/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/ViewMode/ShowFutureReceivables/Content"
  
}) {
let tabSelectedLedgerReceivablesShowFutureReceivablesValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.ledger.receivables.show_future_receivables',
})
let onClick = fromHelpers.useOnToggle({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 marginTop={0}
 marginLeft="auto"
 data="tab.selected.ledger.receivables.show_future_receivables"
 value={tabSelectedLedgerReceivablesShowFutureReceivablesValueData}
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 text="Show future invoices & claims"
/>
</React.Fragment>
)}
</TysiaToggle>
{children}
</React.Fragment>)
}